import { Button, CircularProgress } from '@mui/material'
import React, { ReactNode } from 'react'
import { useHistory } from 'react-router-dom'

interface IFormButton {
  type: 'submit' | 'cancel' | 'back' | 'button'
  variant: 'contained' | 'text'
  label: string
  isDisabled?: boolean
  isLoading?: boolean
  onClick?: () => void
  endIcon?: ReactNode
  startIcon?: ReactNode
}

const FormButton: React.FC<IFormButton> = ({
  label,
  type,
  variant,
  isLoading = false,
  isDisabled = false,
  onClick = () => {},
  endIcon,
  startIcon,
}) => {
  const history = useHistory()

  const isSubmit = type === 'submit'
  const isCancel = type === 'cancel'
  const isBack = type === 'back'

  const handleClick = () => {
    if (type === 'cancel') {
      return history.goBack()
    }

    onClick()
  }

  return (
    <Button
      disabled={isDisabled}
      type={isSubmit ? 'submit' : 'button'}
      variant={variant}
      onClick={handleClick}
      sx={{
        height: '2.625rem',
        maxHeight: '2.625rem',
        padding: '0 1.5rem !important',
        margin: '0rem 0.5rem !important',
        color: isBack || isCancel ? '#000000 !important' : '#FFFFFF !important',

        '& .Mui-disabled': {
          backgroundColor: '#8C9097 !important',
          color: '#FFFFFF !important',
          fontWeight: '500 !important',
        },

        '& .MuiSvgIcon-root': {
          fontSize: '1.5rem',
          color: isBack ? '#000000 !important' : '#FFFFFF !important',
        },
      }}
      endIcon={!isLoading && endIcon}
      startIcon={!isLoading && startIcon}
    >
      {type === 'cancel' ? (
        label
      ) : isLoading ? (
        <CircularProgress
          color='inherit'
          size={26}
        />
      ) : (
        label
      )}
    </Button>
  )
}

export default FormButton
